function pickerWithDefault(options) {
    var defaultPickerObject = {
        icons: {
            time: 'far fa-clock',
            date: 'far fa-calendar',
            up: 'fas fa-chevron-up',
            down: 'fas fa-chevron-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'fas fa-crosshairs',
            clear: 'fas fa-trash',
            close: 'fas fa-times'
        }
    };

    if (!options || $.type(options) !== "object") {
        return defaultPickerObject;
    }

    return $.extend(true, defaultPickerObject, options);
}

$(function () {

    $('.datetime-picker').datetimepicker(
        pickerWithDefault({
            format: dateTimeFormat,
            useCurrent: false
        })
    );

    $('.date-picker').datetimepicker(
        pickerWithDefault({
            format: dateFormat,
            useCurrent: false
        })
    );

    $('.time-picker').datetimepicker(
        pickerWithDefault({
            format: timeFormatRead,
            useCurrent: false
        })
    );

    $('.month-picker').datetimepicker(
        pickerWithDefault({
            viewMode: 'months',
            format: 'MM/01/YYYY',
            useCurrent: false
        })
    );

    ///// Basic datetime selector using datetime-from and datetime-to classes
    //Start Picker
    initilizeDateTimeRange();

    ///// Basic date selector using date-from and date-to classes
    //Start Picker
    initilizeDateRange();

    ///// Basic time selector using time-from and time-to classes
    //Start Picker
    initilizeTimeRange();


    ///// Basic time selector using month-from and month-to classes
    //Start Picker
    initilizeMonthRange();

    $('.datetime-picker-a,.datetime-picker-b,.datetime-picker-d,.datetime-picker-e.date-picker,.time-picker,.month-picker,.datetime-picker,.datetime-from,.datetime-to,.date-from,.date-to,.time-from,.time-to,.range-from,.range-to,.time-range-from,.time-range-to,.date-range-from,.date-range-to')
        .each(function (_i, e) {
            var element = $(e);

            element.attr('autocomplete', 'off');
            var picker = element.data("DateTimePicker");
            if (picker) {
                picker.widgetPositioning({
                    horizontal: element.data('horizontal-position') || 'auto',
                    vertical: element.data('vertical-position') || 'auto'
                });
            }
        });

});

function initilizeDateTimeRange() {

    $('.datetime-from').datetimepicker(
        pickerWithDefault({
            format: dateTimeFormat,
            useCurrent: false
        })
    ).on("dp.change", function (e) {
        var target = $(this.getAttribute('data-range-target'));

        target.data("DateTimePicker").minDate(e.date);
    });


    $('.datetime-to').datetimepicker(
        pickerWithDefault({
            format: dateTimeFormat,
            useCurrent: false
        })
    ).on("dp.change", function (e) {
        var target = $(this.getAttribute('data-range-target'));

        target.data("DateTimePicker").maxDate(e.date);
    });

}

function initilizeTimeRange() {

    $('.time-from').datetimepicker(
        pickerWithDefault({
            format: timeFormatRead,
            useCurrent: false
        })
    ).on("dp.change", function (e) {
        var target = $(this.getAttribute('data-range-target'));

        target.data("DateTimePicker").minDate(e.date);
    });


    $('.time-to').datetimepicker(
        pickerWithDefault({
            format: timeFormatRead,
            useCurrent: false
        })
    ).on("dp.change", function (e) {
        var target = $(this.getAttribute('data-range-target'));

        target.data("DateTimePicker").maxDate(e.date);
    });
}


function initilizeDateRange() {

    $('.date-from').datetimepicker(
        pickerWithDefault({
            format: dateFormat,
            useCurrent: false
        })
    ).on("dp.change", function (e) {
        var target = $(this.getAttribute('data-range-target'));

        target.data("DateTimePicker").minDate(e.date);
    });


    $('.date-to').datetimepicker(
        pickerWithDefault({
            format: dateFormat,
            useCurrent: false
        })
    ).on("dp.change", function (e) {
        var target = $(this.getAttribute('data-range-target'));

        target.data("DateTimePicker").maxDate(e.date);
    });
}


function initilizeMonthRange() {
    $('.month-from').datetimepicker(
        pickerWithDefault({
            format: monthFormat,
            viewMode: 'months',
            useCurrent: false
        })
    ).on("dp.change", function (e) {
        var target = $(this.getAttribute('data-range-target'));

        target.data("DateTimePicker").minDate(e.date);
    });


    $('.month-to').datetimepicker(
        pickerWithDefault({
            format: monthFormat,
            viewMode: 'months',
            useCurrent: false
        })
    ).on("dp.change", function (e) {
        var target = $(this.getAttribute('data-range-target'));

        target.data("DateTimePicker").maxDate(e.date);
    });
}
